<template>
  <myhead :value="value" @next="next" @lookmore="more">{{
    $route.query.title || $route.meta.title
  }}</myhead>
  <div>
    <div class="flex accident-up">
      <img :src="accident.thumb" :onerror="Imgerror">
      <div class="accident-up-txt">
        <p>{{ accident.name }}</p>
        <p>{{ accident.spec_key_name }}</p>
        <!-- <p>已收货5天</p> -->
      </div>
    </div>
    <div class="accident-bottom">
      <div>
        <p class="a345 size15">一、选择您的问题类型</p>
        <select :style='`background-image:url(${imgIcon})`' name="" id="" class="accident-bottom__select" v-model=" question">
          <option :value="item.title" v-for="item in accident.question_list" :key="item.id">{{ item.title }}</option>
        </select>
      </div>
      <div style="margin-top: 5.3333vw;">
        <p class="a345 size15">二、上传诉呈</p>
        <div class="uploader-box">
          <van-uploader :after-read="uploadImg" name="file" :preview-image="true" v-model="fileList" max-count="1" :before-delete="handleImgdel" />
        </div>
      </div>
      <div style="margin-top: 5.3333vw;">
        <p class="a345 size15"></p>
        <div class="slimg">
          <img :src="accident.sample_img" :onerror="Imgerror">
        </div>
      </div>
    </div>
  </div>
  <div class="subbar flex between center">
    <p @click="handleReset">重置</p>
    <button @click="handleSubmit">确认提交</button>
  </div>
  <van-popup v-model:show="tipshow" style="width: 100%; border-radius: 5px">
    <div class="tipbox">
      <img src="@/assets/img/icon32.png" class="closeimg" @click="$router.go(-1)" />
      <div class="flex center cen tiptle">
        <img src="@/assets/img/icon60.png" />
        <p class="size18 weight mt10">
          事故申诉风险须知
        </p>
      </div>
      <div class="tipcon">
        <p v-html="info"></p>
        <button class="size14" @click="handleCloseTip">我已知晓，下一步</button>
      </div>
    </div>
  </van-popup>
</template>
<script>
import ajax from "@/utils/request.js";
import { showToast } from "vant";
export default {
  data () {
    return {
      imgIcon: require('@/assets/img/icon66.png'),
      uploadimg: "",//带www地址的
      imgaddress: "",//不带域名的
      accident: {},
      question: "",
      fileList: [],
      tipshow: true,
      info: ""
    }
  },
  methods: {
    uploadImg (file) {
      const data = {
        file: file.file
      }
      ajax.post("api/dyuploadimg", data).then(res => {
        this.uploadimg = res.data.img,
          this.imgaddress = res.data.url
      })
    },
    handleSubmit () {
      const data = {
        id: this.$route.query.id,
        question: this.question,
        complaint: this.imgaddress
      }
      ajax.post("accident/accidentsubmit", data).then(res => {
        if (res.errcode === 1) {
          showToast(res.message)
          history.go(-1)
        }
      })
    },
    handleReset () {
      this.fileList = []
      this.question = "",
        this.imgaddress = "",
        this.uploadimg = ""
    },
    handleImgdel () {
      this.fileList = []
      this.uploadimg = ""
      this.imgaddress = ""
    },
    handleCloseTip () {
      this.tipshow = false;
    },
  },
  created () {
    ajax.post("accident/accident", { id: this.$route.query.id }).then(res => {
      // console.log(res);
      this.accident = res.data
    })
    ajax.post("api/getagreement", { typeid: 8 }).then(res => {
      this.info = res.data.content
    })
  }
}
</script>
<style scoped lang="scss">
.accident-up {
    background-color: #fff;
    padding: 3.2vw 4vw;
    align-items: flex-start;
}
.accident-up img {
    display: block;
    width: 26.6667vw;
    height: 26.6667vw;
    background-color: #f6f6f6;
}
.accident-up-txt {
    margin-left: 2.6667vw;
}
.accident-up-txt p {
    font-size: 14px;
    color: #333333;
}
.accident-up-txt p:first-child {
    width: 61.3333vw;
}
.accident-up-txt p:nth-child(2) {
    color: #999999;
    margin-top: 2.6667vw;
    margin-bottom: 2.6667vw;
}
.accident-up-txt p:last-child {
    color: #3F7C93;
}
.accident-bottom {
    margin-top: 2.6667vw;
    background-color: #fff;
    padding: 3.2vw 4vw 60px;
    select{
      appearance: none;
      -moz-appearance:none;
      -webkit-appearance:none;
      width: 100%;
      padding: 0 15px;
      background:  no-repeat right 15px center;
      background-size:3.5vw;
      background-color: #f6f6f6;
      option{
        background-color: #fff;
      }
    }
}
.accident-bottom__select {
    width: 92vw;
    height: 9.6vw;
    border-radius: 4.8vw;
    margin-top: 2.6667vw;
}
.uploader-box {
    margin-top: 2.6667vw;
}
.subbar {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #fff;
    padding: 3.7333vw;
    box-shadow: 0px -1px 5.3333vw 0px rgba(0,0,0,0.08);
}
.subbar p {
    font-size: 14px;
    color: #3F7C93;
}
.subbar button {
    width: 78.6667vw;
    height: 9.6vw;
    line-height: 9.6vw;
    text-align: center;
    background: #3F7C93;
    border-radius: 5.6vw;
    font-size: 14px;
    color: #fff;
}
.slimg {
    display: block;
    width: 100%;
    margin: 2.6667vw auto;
}

.tiptle {
  img {
    display: block;
    width: 6.4vw;
    margin-right: 2.6667vw;
  }
  p {
    color: #333333;
    letter-spacing: 1px;
  }
}
.tipcon {
  margin-top: 6.4vw;
  p {
    margin-bottom: 5.3333vw;
    line-height: 1.4;
  }
}
.tipbox {
  position: relative;
  padding: 5.3333vw 4vw;
  button {
    width: 74.6667vw;
    height: 9.6vw;
    line-height: 9.6vw;
    text-align: center;
    background: #3f7c93;
    border-radius: 5.6vw;
    color: #ffffff;
    font-size: 14px;
  }
  .closeimg {
    width: 4.2667vw;
    position: absolute;
    top: 4.2667vw;
    right: 4.2667vw;
  }
}
</style>